/**
 * Polyfills
 */
import 'babel-polyfill'
import 'whatwg-fetch'
import objectFitImages from 'object-fit-images'

/**
 * Application
 */
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex'

/**
 * Plugins
 */
import { isDev } from '@heavyy-utils/utils'
import '@heavyy-utils/browser-version'
import Monitoring from '@heavyy-utils/vue/monitoring'
import Analytics from '@heavyy-utils/vue/analytics'

/**
 * Fonts
 */
import 'sparnord-assets/fonts/gilroy/medium' // 500
import 'sparnord-assets/fonts/gilroy/semi-bold' // 600
import 'sparnord-assets/fonts/gilroy/bold' // 700
import 'sparnord-assets/fonts/gilroy/extra-bold' // 800
import 'sparnord-assets/fonts/gilroy/black' // 900

Vue.config.productionTip = isDev()

Vue.use(Monitoring, {
  sentry: isDev() ? undefined : 'https://63e0d8d85e954e42add912ef35ebdee2@sentry.io/1052551'
})

Vue.use(Analytics, {
  router,
  ga: 'UA-39287258-28',
  pixel: 157490608209128
})

//* Object-fit polyfill */
objectFitImages()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js